var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mx-auto mt-5", attrs: { id: "analysis-categs" } },
    [
      _c("div", { attrs: { id: "brief" } }, [
        _c(
          "div",
          { attrs: { id: "briefs" } },
          _vm._l(_vm.indexCompare, function(idx) {
            return _c("IndexBrief", {
              key: idx.title,
              attrs: {
                location: _vm.location,
                indexCompare: idx,
                countyList: _vm.countyList,
                townList: _vm.townList
              }
            })
          }),
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "topics my-5 d-none d-sm-flex" },
        [
          _c(
            "swiper",
            {
              ref: "topicSwiper",
              staticClass: "swiper",
              attrs: { options: _vm.swiperOption }
            },
            [
              _vm._l(_vm.topics, function(topic) {
                return _c(
                  "swiper-slide",
                  {
                    key: topic,
                    staticClass: "topic px-2 mr-2",
                    class: { active: _vm.topicSelected == topic }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "btn btn-block text-center",
                        on: {
                          click: function($event) {
                            _vm.topicSelected = topic
                          }
                        }
                      },
                      [_vm._v(_vm._s(topic))]
                    )
                  ]
                )
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-button-prev",
                attrs: { slot: "button-prev" },
                slot: "button-prev"
              }),
              _vm._v(" "),
              _c("div", {
                staticClass: "swiper-button-next",
                attrs: { slot: "button-next" },
                slot: "button-next"
              })
            ],
            2
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "topics my-5 d-sm-none" }, [
        _c("div", { staticClass: "form-row" }, [
          _c(
            "select",
            {
              staticClass: "form-control col-12",
              on: {
                change: function($event) {
                  _vm.changeTopic($event)
                }
              }
            },
            _vm._l(_vm.topics, function(topic) {
              return _c(
                "option",
                {
                  key: topic,
                  domProps: { selected: _vm.topicSelected == topic }
                },
                [_vm._v("\n          " + _vm._s(topic) + "\n        ")]
              )
            }),
            0
          )
        ])
      ]),
      _vm._v(" "),
      _vm.topicSelected != null
        ? _c("TopicContent", {
            attrs: {
              location: _vm.location,
              categ: _vm.categ,
              subcateg: _vm.currentSubcateg
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }